
const kycSpecialCharacterConstrains = (isRequired = true,ErrorMessageForIsRequired,otherValidations={}) => {
  return (
    { required: {
        value: isRequired,
        message: ErrorMessageForIsRequired,
      } ,
      pattern: {
        // value: /^[^"'<>]+$/,
        value: /^[^"<>]+$/,
        message: 'Special characters are not allowed',
      } ,
      ...otherValidations
    }
  )
}

export default kycSpecialCharacterConstrains
